export const environment = {
  production: false,
  apiUrl: 'https://tiaky-arc.tim.it/ingestion/api/v1',
  keycloak: {
    url: 'https://auth.tiaky-arc.tim.it/',
    realm: 'tiaky-arc',
    clientId: 'backoffice-console',
  }
};
